import { api } from '@/lib/api/client'
import type { MyOrganization } from '@/features/organizations/types/organization'

/** `GET /organizations/my` returns every organization (with its workspaces) the user holds a role in. */
export async function getMyOrganizations(): Promise<MyOrganization[]> {
  const { data } = await api.get<{ data: MyOrganization[] }>('/organizations/my')

  return data.data
}
